export function initNav({ scrollToId }) {
  const toggle = document.getElementById('nav-toggle');
  const nav = document.getElementById('primary-nav');
  const backdrop = document.getElementById('nav-backdrop');
  if (!toggle || !nav) return;

  const links = [...nav.querySelectorAll('a')];

  function setOpen(open) {
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    nav.classList.toggle('is-open', open);
    document.body.classList.toggle('nav-open', open);
    if (backdrop) {
      backdrop.hidden = !open;
      backdrop.classList.toggle('is-visible', open);
    }
    if (open) {
      links[0]?.focus();
    } else {
      toggle.focus();
    }
  }

  toggle.addEventListener('click', () => {
    const open = toggle.getAttribute('aria-expanded') !== 'true';
    setOpen(open);
  });

  backdrop?.addEventListener('click', () => setOpen(false));

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
      setOpen(false);
    }
  });

  nav.addEventListener('keydown', (e) => {
    if (toggle.getAttribute('aria-expanded') !== 'true') return;
    if (e.key !== 'Tab') return;
    const focusable = [toggle, ...links];
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  links.forEach((a) => {
    a.addEventListener('click', (e) => {
      const href = a.getAttribute('href') || '';
      if (href.includes('#')) {
        const id = href.split('#')[1];
        if (id) {
          e.preventDefault();
          window.history.pushState({}, '', `/#${id}`);
          scrollToId(id);
        }
      }
      if (toggle.getAttribute('aria-expanded') === 'true') setOpen(false);
    });
  });

  const sectionIds = ['overview', 'homes', 'gallery', 'site-plan', 'location', 'downloads', 'register'];
  const sections = sectionIds.map((id) => document.getElementById(id)).filter(Boolean);
  if ('IntersectionObserver' in window && sections.length) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((en) => {
          if (!en.isIntersecting) return;
          const id = en.target.id;
          links.forEach((l) => {
            const active = (l.getAttribute('href') || '').endsWith(`#${id}`);
            l.classList.toggle('is-active', active);
          });
        });
      },
      { rootMargin: '-40% 0px -50% 0px', threshold: 0.01 },
    );
    sections.forEach((s) => io.observe(s));
  }
}
